export default __webpack_public_path__ + "images/SK.d5dd501.png";